import { render, staticRenderFns } from "./RenewPasswordSuccess.vue?vue&type=template&id=74f6818e&"
import script from "./RenewPasswordSuccess.vue?vue&type=script&lang=js&"
export * from "./RenewPasswordSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports